import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './app/App.tsx'
import ErrorBoundary from './app/components/common/ErrorBoundary.tsx'
import reportWebVitals from './reportWebVitals'
import { PostHogProvider } from 'posthog-js/react'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
        autocapture: true,
      }}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
)

reportWebVitals()
